import { useAtom } from 'jotai';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { userAtom } from '../jotai-atoms/user.atom';
import { Icon } from './Icon';
import { Modal, ModalProps } from './Modal';

export interface ModalPlatformTourFeedbackPendingProps {
  show: boolean;
  onClose: () => void;
}

const SERVICES_TEAM_LATAM_URL = 'https://www.openenglish.com/soporte/';
const SERVICES_TEAM_BR_URL = 'https://www.openenglish.com.br/junior/suporte/';

export const ModalPlatformTourFeedbackPending: React.FC<ModalPlatformTourFeedbackPendingProps> = ({
  show,
  onClose,
}) => {
  const [user] = useAtom(userAtom);
  const __ = useTranslation().t;

  const servicesTeamUrl = user?.lang === 'pt-BR' ? SERVICES_TEAM_BR_URL : SERVICES_TEAM_LATAM_URL;

  const modalProps: ModalProps = {
    show,
    onClose,
    type: 'default',
    title: __('waitingConfirmation'),
    submitButtonText: __('ok'),
  };

  return (
    <StyledModal {...modalProps} onSubmit={onClose} onClose={onClose}>
      <Container>
        <StyledIcon name="triangle-exclamation" />
        <div>
          <Trans
            alt={__('platformTourConfirmationWaitServiceTeamOrContactServicesTeam')}
            i18nKey="platformTourConfirmationWaitServiceTeamOrContactServicesTeam"
          >
            Wait for our service team to confirm your assistance to the Platform Tour so you can
            start taking Live Classes. Please try again later or if the problem persists you can get
            in touch with our{' '}
            <a href={servicesTeamUrl} target="_blank">
              services team
            </a>
            .
          </Trans>
        </div>
      </Container>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  max-width: 560px;
`;

const StyledIcon = styled(Icon)`
  margin-right: 16px;
  font-size: 40px;
  color: #ffcc00;
`;

const Container = styled.div`
  display: flex;
  align-items: start;
  font-family: 'Inter';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.dark};
  padding-bottom: 8px;
`;
